import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons";
import localization from "../../../config/localization";
import { GetBalanceResponse } from "../../home/models";
import { useDisableBackgroundScrolling } from "../../../hooks/DisableBackgroundScrolling";

export interface UserWalletWidgetProps {
  userBalanceResponse: GetBalanceResponse;
  isOpen: boolean;
}

export function UserWalletWidget({
  userBalanceResponse,
  isOpen,
}: UserWalletWidgetProps) {
  useDisableBackgroundScrolling(isOpen);

  if (!isOpen) return null;

  return (
    <div
      className="
        z-50 overflow-y-auto max-h-72
        max-sm:fixed max-sm:inset-x-4 max-sm:top-[5.25rem] max-sm:w-auto max-sm:max-w-none
        sm:absolute sm:top-full sm:mt-2 sm:right-0 sm:left-auto sm:w-80 sm:max-w-[20rem]
        lg:-right-11
        bg-black border border-[#2a2a2a] rounded-xl shadow-xl p-4
      "
    >
      <h3 className="text-white font-semibold mb-4">{localization.wallet}</h3>

      <div className="space-y-4 text-sm">
        {/* Main Wallet */}
        <div className="flex justify-between items-center gap-2 border-b border-[#1f1f1f] pb-2">
          <div className="flex min-w-0 items-center gap-2">
            <div className="flex shrink-0 items-center justify-center">
              <img
                src="/icons/ic-wallet.svg"
                alt="wallet"
                className="w-8 h-8 object-contain"
              />
            </div>

            <span className="truncate text-gray-400">
              {localization.realmoney}
            </span>
          </div>

          <span className="flex min-w-0 max-w-[55%] items-center justify-end gap-1 font-bold text-white">
            <FontAwesomeIcon icon={faIndianRupeeSign} className="shrink-0" />
            <span className="truncate text-right tabular-nums">
              {Number(userBalanceResponse?.mainWalletAmount ?? 0).toFixed(2)}
            </span>
          </span>
        </div>

        {/* Withdrawable Balance */}
        <div className="flex justify-between items-center gap-2 border-b border-[#1f1f1f] pb-2">
          <div className="flex min-w-0 items-center gap-2">
            <div className="flex shrink-0 items-center justify-center">
              <img
                src="/icons/ic-withdraw.svg"
                alt="withdraw"
                className="w-8 h-8 object-contain"
              />
            </div>

            <span className="truncate text-gray-400">
              {localization.withdrawable}
            </span>
          </div>

          <span className="flex min-w-0 max-w-[55%] items-center justify-end gap-1 font-bold text-white">
            <FontAwesomeIcon icon={faIndianRupeeSign} className="shrink-0" />
            <span className="truncate text-right tabular-nums">
              {Number(userBalanceResponse?.withdrawBalance ?? 0).toFixed(2)}
            </span>
          </span>
        </div>

        {/* Exchange Balance */}
        <div className="flex justify-between items-center gap-2 border-b border-[#1f1f1f] pb-2">
          <div className="flex min-w-0 items-center gap-2">
            <div className="flex shrink-0 items-center justify-center">
              <img
                src="/icons/ic-exchange.svg"
                alt="exchange"
                className="w-8 h-8 object-contain"
              />
            </div>

            <span className="truncate text-gray-400">
              {localization.exchangebalance}
            </span>
          </div>

          <span className="flex min-w-0 max-w-[55%] items-center justify-end gap-1 font-bold text-white">
            <FontAwesomeIcon icon={faIndianRupeeSign} className="shrink-0" />
            <span className="truncate text-right tabular-nums">
              {Number(userBalanceResponse?.exchangeBalance ?? 0).toFixed(2)}
            </span>
          </span>
        </div>

        {/* Exposure */}
        <div className="flex justify-between items-center gap-2">
          <div className="flex min-w-0 items-center gap-2">
            <div className="flex shrink-0 items-center justify-center">
              <img
                src="/icons/ic-transaction.svg"
                alt="exposure"
                className="w-8 h-8 object-contain"
              />
            </div>

            <span className="truncate text-gray-400">
              {localization.exchangeexposure}
            </span>
          </div>

          <span className="flex min-w-0 max-w-[55%] items-center justify-end gap-1 font-bold text-red-500">
            <FontAwesomeIcon icon={faIndianRupeeSign} className="shrink-0" />
            <span className="truncate text-right tabular-nums">
              {Number(userBalanceResponse?.exposure ?? 0).toFixed(2)}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}
